$(function(){
	$('.js-cascading-delay').each(function(){
    	var delay = 0.01;
    	$(this).children().each(function(index){
    		$(this).css('transition-delay', delay*(index+2)+'s');
    	});
    });
});